import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { NavItemTypeEnum, type NavAction, type NavItem, type NavItemContext } from '@/common/types/navigation'
import { type IModuleContext } from '@/common/types/module'

export class CompanyNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(context: IModuleContext, action: NavAction<any>) {
    super(context, action)
    this.textKey = 'assist.action.company'
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    yield {
      ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.EventModal),
      target: 'open-create-company-modal',
    } as NavItem
  }
}
